import { Tab, Tabs } from 'e100-react-components';
import React, { ChangeEvent } from 'react';
import { useIntl } from 'react-intl';
import { useStationSelectedTabContext } from '../context';
import { StationTabType } from '../types';
import { useStyles } from './styles';

export const StationSelectedSwitcher = ({ allStationCount, selectedStationCount }: StationSelectedSwitcherProps) => {
  const { formatMessage } = useIntl();
  const { activeTab, setActiveTab } = useStationSelectedTabContext();
  const classes = useStyles();

  const handleTabChange = (_: ChangeEvent<{}>, value: StationTabType) => {
    if (value) {
      setActiveTab(value);
    }
  };

  return (
    <Tabs
      value={activeTab}
      //@ts-ignore
      onChange={handleTabChange}
      variant="fullWidth"
      indicatorColor="primary"
      textColor="primary"
    >
      <Tab
        value={StationTabType.ALL_STATIONS}
        label={`${formatMessage({ id: 'allStations' })} ${allStationCount ? `: ${allStationCount}` : ''}`}
        classes={{
          root: classes.tabLabel,
        }}
      />
      <Tab
        value={StationTabType.SELECTED}
        label={`${formatMessage({ id: 'selected' })} ${selectedStationCount ? `: ${selectedStationCount}` : ''}`}
        classes={{
          root: classes.tabLabel,
        }}
      />
    </Tabs>
  );
};

interface StationSelectedSwitcherProps {
  allStationCount?: number;
  selectedStationCount?: number;
}
